// Single Webinar page: a live countdown ticker for upcoming webinars, and a play button that swaps
// the hero facade for a real video embed once clicked.

function initCountdown() {
  const els = document.querySelectorAll('.section-webinar-single__countdown[data-target-ts]');
  if (!els.length) return;

  function render() {
    const now = Date.now();

    els.forEach((el) => {
      const target = parseInt(el.dataset.targetTs, 10);
      if (!target) return;

      const diff = target - now;
      if (diff <= 0) {
        el.textContent = 'Live now';
        return;
      }

      const totalMinutes = Math.floor(diff / 60000);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      el.textContent = `${days}d : ${hours}h : ${minutes}m`;
    });
  }

  render();
  setInterval(render, 60000);
}

// Build the embed markup for a given video URL. Returns an HTML string, or
// null if the URL isn't recognised (caller then just opens it in a new tab).
function buildEmbed(url) {
  // YouTube — watch?v=, youtu.be/, /embed/, /shorts/.
  const yt = url.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
  );
  if (yt) {
    const id = yt[1];
    return `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0" title="Webinar recording" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
  }

  // Vimeo — vimeo.com/123456789 (optionally with a privacy hash).
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/(\w+))?/);
  if (vimeo) {
    const id = vimeo[1];
    const hash = vimeo[2] ? `?h=${vimeo[2]}&autoplay=1` : '?autoplay=1';
    return `<iframe src="https://player.vimeo.com/video/${id}${hash}" title="Webinar recording" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
  }

  // Direct media file.
  if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url)) {
    return `<video src="${url}" controls autoplay playsinline></video>`;
  }

  return null;
}

function initVideo() {
  const boxes = document.querySelectorAll('.section-webinar-single__video[data-video-url]');
  if (!boxes.length) return;

  boxes.forEach((box) => {
    const btn = box.querySelector('.section-webinar-single__play');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const url = box.dataset.videoUrl;
      if (!url) return;

      const embed = buildEmbed(url);
      if (!embed) {
        window.open(url, '_blank', 'noopener');
        return;
      }

      box.insertAdjacentHTML('beforeend', embed);
      box.classList.add('is-playing');
    });
  });
}

export default function initWebinarSingle() {
  initCountdown();
  initVideo();
}
